<div class="row" *ngIf="displayType==='acknowledgment'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{head}} </span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="form">
                <div class="row d-felx justify-content-center">

                    <div class="col-sm-12 col-md-8 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>comment 1</mat-label>
                            <input matInput formControlName="comment1" placeholder="Enter comment 1" class="col-10"
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-8 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>comment 2</mat-label>
                            <input matInput formControlName="comment2" placeholder="Enter comment 2" class="col-10"
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-12 col-md-12 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>comment 3</mat-label>
                        <input matInput   formControlName="comment3"
                            placeholder="Enter comment 3" class="col-10" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-12 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>comment 4</mat-label>
                        <input matInput   formControlName="comment4"
                            placeholder="Enter comment 4" class="col-10" autocomplete="off">
                    </mat-form-field>
                </div> -->
                    <div class="col-md-8 mt-4"
                        *ngIf="this.data.serviceproviderId!=1 && this.data.serviceproviderId!=6 && this.data.serviceproviderId!=14">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Reason Type</mat-label>
                            <mat-select class="scrollbarcs" formControlName="cancellationReasonByAdmin"
                                placeholder="Select Cancelation Reason ">
                                <mat-select-filter [displayMember]="'value'" [array]="reasonType"
                                    (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="d-flex justify-content-between mt-4">
                    <div class="mt-4" style="font-size: medium;">


                        <div *ngIf="form.value.commentCreatedTs">
                            <p>Created By: {{data.commentCreatedBy}} on {{data.commentCreatedTs |
                                date:'dd/MM/yyyyHH:mm:ss'}}</p>
                        </div>
                        <div *ngIf="form.value.commentModifiedTs">
                            <p>Modified By: {{data.commentModifiedBy}} on {{data.commentModifiedTs | date:'dd/MM/yyyy
                                HH:mm:ss'}}</p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-item-center  button-style mt-3">
                        <button class="btn btn-primary my-2 mr-3" type="button" style="height: auto;" (click)="Close()"
                            matButton>Cancel</button>
                        <button class="btn btn-secondary my-2" type="submit" style="height: auto;" (click)="onsubmit()"
                            matButton>Submit</button>
                    </div>
                </div>



            </form>
        </div>
    </div>
</div>

<div class="row" *ngIf="displayType!='acknowledgment'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{head}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="vapproveform">

                <!-- service chamge -->

                <div class="row mt-3" *ngIf="head!='Cancellation Confirmation'">

                    <div class="col-xl-6 mt-4" *ngIf="displayType != 'ismanual' && displayType != 'reject'">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Service Change effective date</mat-label>
                            <input readonly matInput [matDatepicker]="startDatePicker" formControlName="effectivedate"
                                autocomplete="off" [min]="nextDate" placeholder="Select From Date"
                                class="custom-input-border" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-9 mt-4 ml-5" *ngIf="displayType == 'ismanual'">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Service Change effective date</mat-label>
                            <input readonly matInput [matDatepicker]="startDatePicker" formControlName="effectivedate"
                                autocomplete="off" [min]="nextDate" placeholder="Select From Date"
                                class="custom-input-border" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-12 mt-4" *ngIf="displayType === 'reject'">

                        <!--  <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                            style="border-radius: 0 !important;">
                            <mat-label>Reason</mat-label>
                            <textarea rows="2" matInput type="text" placeholder="Enter Query" formControlName="reason"
                                autocomplete="off" specialIsAlphaNumeric class="col-12"></textarea>
                        </mat-form-field>-->

                        <div class="row mt-1">
                            <div class="col-12">
                                <mat-form-field appearance="fill" hideRequiredMarker style="width: 100%;">
                                    <mat-label>Reason</mat-label>
                                    <mat-select formControlName="reason" placeholder="Select Reason">
                                        <mat-select-filter [displayMember]="'value'" [array]="rejectReasonList"
                                            (filteredReturn)="filteredRejectReasonList = $event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let reason of filteredRejectReasonList"
                                            [value]="reason.key">
                                            {{ reason.value }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12">
                                <mat-form-field appearance="fill" hideRequiredMarker style="width: 100%;">
                                    <mat-label>Retention agent name</mat-label>
                                    <mat-select formControlName="retentionAgent" placeholder="Select Retention Agent">
                                        <mat-select-filter [displayMember]="'firstName'" [array]="hcUserList"
                                            (filteredReturn)="filteredHCUserList = $event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let user of filteredHCUserList" [value]="user.userId">
                                            {{ user.firstName }} {{ user.lastName }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- <div class="row mt-3">
                            <div class="col-12" *ngIf="isPromotionChecked">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Promo Code</mat-label>
                                    <input matInput appAlphaNumeric type="text" id="promo"
                                        formControlName="retentionPromoCode" autocomplete="off" readonly ="col-12">
                                </mat-form-field>
                            </div>
                        </div> -->

                        <div class="row mt-3">
                            <div class="col-12" *ngIf="isPromotionChecked">
                                <mat-form-field appearance="fill" hideRequiredMarker style="width: 100%;">
                                    <mat-label>Retention Promo Code</mat-label>
                                    <mat-select formControlName="retentionPromoCode" placeholder="Select Promo Code"
                                        (selectionChange)="onRetentionPromoCodeSelected($event)">
                                        <mat-select-filter [displayMember]="'firstName'" [array]="retentionPromoList"
                                            (filteredReturn)="retentionPromoList = $event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let promo of retentionPromoList" [value]="promo">
                                            {{ promo }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12" style="margin-bottom: 10px;" *ngIf="isRetentionPromoCodeSelected">
                                <div class="promo-card">
                                    <div class="price-row">
                                        <span>Current Product Price (R)</span>
                                        <span>{{matchedRetentionPromo.originalPriceIncVat}}</span>
                                    </div>
                                    <div class="price-row">
                                        <span>Discounted Price (R)</span>
                                        <span>{{-matchedRetentionPromo.discountedPriceIncVat}}</span>
                                    </div>

                                    <mat-divider style="border-top-color: blueviolet;"></mat-divider>

                                    <div class="price-row">
                                        <strong>Total (R)</strong>
                                        <strong>{{matchedRetentionPromo.savingsAmount}}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-0 ml-2"
                            *ngIf="isNotRecurringDate && isRetentionPromoApplicable && isEmailAllowed">
                            <div class="col-12" style="margin-left: -16px;">
                                <mat-checkbox style="transform: scale(1.3);" color="primary"
                                    [checked]="isPromotionChecked" (change)="promotionChange($event)"></mat-checkbox>
                                <label style="margin-left: 16px; font-size: large; white-space: nowrap;">
                                    Would you like to apply Retention Promotion?
                                </label>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-12 col-md-6 mt-4" *ngIf="displayType === 'vapprove'">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>vumatelNetworkIdentifier</mat-label>
                            <input matInput maxlength="25" formControlName="vumatelNetworkIdentifier" class="col-10"
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4"
                        *ngIf="(displayType === 'approve'||displayType === 'bapprove') && vapproveform.getRawValue().fsan!=null">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Line Number/FSAN</mat-label>
                            <input matInput maxlength="25" formControlName="fsan" class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mt-3" *ngIf="head=='Cancellation Confirmation'">
                    <div class="col-xl-6 "
                        *ngIf="displayType != 'ismanual' && displayType != 'reject' && vapproveform.getRawValue().fsan!=''">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Cancellation effective date</mat-label>
                            <input readonly matInput [matDatepicker]="startDatePicker" formControlName="effectivedate"
                                autocomplete="off" [min]="nextDate" placeholder="Select From Date"
                                class="custom-input-border" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- <div class="col-xl-9  ml-5"
                        *ngIf="displayType != 'ismanual' && displayType != 'reject' && vapproveform.getRawValue().fsan!=null">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Cancellation effective date</mat-label>
                            <input readonly matInput [matDatepicker]="startDatePicker" formControlName="effectivedate"
                                autocomplete="off" [min]="nextDate" placeholder="Select From Date"
                                class="custom-input-border" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div> -->

                    <div class="col-xl-9  ml-5" *ngIf="displayType == 'ismanual'">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Cancellation effective date</mat-label>
                            <input readonly matInput [matDatepicker]="startDatePicker" formControlName="effectivedate"
                                autocomplete="off" [min]="nextDate" placeholder="Select From Date"
                                class="custom-input-border" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-11 " *ngIf="displayType === 'reject'">

                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                            style="border-radius: 0 !important;">
                            <mat-label>Reason</mat-label>
                            <textarea rows="2" matInput type="text" placeholder="Enter Query" formControlName="reason"
                                autocomplete="off" specialIsAlphaNumeric class="col-12"></textarea>
                        </mat-form-field>


                    </div>
                    <div class="col-sm-12 col-md-6 " *ngIf="displayType === 'vapprove'">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>vumatelNetworkIdentifier</mat-label>
                            <input matInput maxlength="25" formControlName="vumatelNetworkIdentifier" class="col-10"
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6"
                        *ngIf="(displayType === 'approve'||displayType === 'bapprove') && vapproveform.getRawValue().fsan!=null">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Line Number/FSAN</mat-label>
                            <input matInput maxlength="25" formControlName="fsan" class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>


                <div class="col-xl-12 mt-4" *ngIf="(displayType === 'vapprove' || isamend==='isamend' )&& isvumatel">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reason</mat-label>
                        <mat-select class="scrollbarcs" formControlName="cancelreason"
                            placeholder="Select Primary Product ">
                            <mat-select-filter [displayMember]="'value'" [array]="reasonList"
                                (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredList1" [value]="item"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-xl-12 mt-4" *ngIf="(displayType === 'vapprove' || isamend==='isamend') && isfrogfoot">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reason</mat-label>
                        <mat-select class="scrollbarcs" formControlName="Frongfootreason"
                            placeholder="Select Primary Product ">
                            <mat-select-filter [displayMember]="'value'" [array]="reasonList"
                                (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredList1" [value]="item"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>


                <div class="row" *ngIf="displayType==='bapprove'">
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Complex / Estate</mat-label>
                            <mat-select class="scrollbarcs" formControlName="balwinComplexType"
                                (filteredReturn)="filteredList= $event" placeholder="Select Complex / Estate ">
                                <mat-select-filter [displayMember]="'value'" [array]="complexlist"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Complex Unit No</mat-label>
                            <input matInput maxlength="25" formControlName="complexUnitNo" class="col-10"
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-4" *ngIf="IsshoppingOrders">
                    <div class="col-sm-12 col-md-12 align-self-center" style="display: flex; align-items: center;">
                        <label style="margin-right: 30px; font-size: large;">Cancel Phone line & Static
                            IP?</label>
                        <mat-radio-group formControlName="radioResult"
                            style="display: flex; flex-direction: row; gap: 80px;">
                            <mat-radio-button value="true">Yes</mat-radio-button>
                            <mat-radio-button class="ml-3" value="false">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>


                <div class="d-flex justify-content-center button-style mt-3">
                    <button class="btn btn-primary my-2 mr-3" type="submit" (click)="Close()" matButton>No</button>
                    <button class="btn btn-secondary my-2 " type="submit" (click)="approveonsubmit()"
                        matButton>Yes</button>

                </div>
            </form>
        </div>

    </div>
</div>